import { useEffect, useState, useCallback, useRef } from "react";
import { getPaginatedValidationRunScoringConfigs } from "../services/scoringService";

interface IuseFetchPaginatedValidationRunScoringConfigs {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  page: any;
  pSize: any;
  runInstanceId?: number | null;
  resourceId?: number | null;
  isActive?: boolean;
}

const useFetchPaginatedValidationRunScoringConfigs = ({
  setIsLoading,
  page,
  pSize,
  runInstanceId,
  resourceId,
  isActive,
}: IuseFetchPaginatedValidationRunScoringConfigs) => {
  const [data, setData] = useState<any>([]);
  const abortControllerRef = useRef<AbortController | null>(null);

  const fetchData = useCallback(async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    setIsLoading(true);
    try {
      const result = await getPaginatedValidationRunScoringConfigs({
        page,
        pSize,
        runInstanceId,
        resourceId,
        isActive,
      });
      setData(result);
    } catch (err: any) {
      if (err.name !== "AbortError") {
        setData([]);
      }
    } finally {
      setIsLoading(false);
    }
  }, [page, pSize, runInstanceId, resourceId, isActive, setIsLoading]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return [data, fetchData];
};

export default useFetchPaginatedValidationRunScoringConfigs;
